<template>
    <div class="fixed-page">
        <!-- 筛选工具 -->
        <!-- <toolbar ref="bar" :filterLoading="tableloading" @filterList="handleFilter"></toolbar> -->

        <div class="margin-container" :style="{'margin-top': barHeight}">
            <!-- 回流分析 -->
            <div class="desc-box">
                <h3 class="title">回流分析</h3>
                <span class="text">针对游戏流失用户（或称沉默用户），追踪其被广告召回的效果。</span>
                <span class="link" @click="handleJump">了解更多<i class="el-icon-arrow-right"></i></span>
            </div>
            <!-- 操作 -->
            <div class="operate-box">
                <!-- 切换按钮组 -->
                <el-radio-group v-model="monitor">
                    <el-radio-button label="date">日期维度</el-radio-button>
                    <el-radio-button label="promotion">监测维度</el-radio-button>
                </el-radio-group>
                <!-- 筛选 下载 -->
                <div class="operate-right">
                    <el-button class="button_style" :loading="downloadListLoading" @click="handleDownloadList">
                        <svg-icon icon-class="download_list" />
                        <span class="button_span_style">导出任务列表</span>
                    </el-button>

                    <el-button class="button_style" :loading="downloadLoading" @click="handleDownload">
                        <svg-icon icon-class="download_shape" />
                        <span class="button_span_style">下载</span>
                    </el-button>

                    <el-button class="button_style" @click="handleEditNorm">
                        <svg-icon icon-class="combined_shape" />
                        <span class="button_span_style">筛选列</span>
                    </el-button>
                </div>
            </div>
            
            <!-- 表格 -->
            <el-table ref="table" class="grayTableTile_02" v-loading="tableloading" :data="tableData.records.result" show-summary :summary-method="getSummaries" @sort-change="handleAgeSortChange">
                <el-table-column v-for="(item,index) in tableData.headers" :key="index"  v-if="item.checked"
                    :label="item.label" 
                    :property="item.property" 
                    :fixed="index == 0" 
                    :min-width="item.width" 
                    show-overflow-tooltip
                    :sortable="item.sortFlag ? 'custom' : false"
                >
                    <!-- 表头 -->
                    <template slot="header" slot-scope="scope">
                        <div style="height:32px;display:flex;align-items:center">
                            <span>{{item.label}}</span>
                            <el-popover v-if="item.extra"
                                placement="top-start"
                                width="300"
                                trigger="hover"
                                :content="item.extra">
                                <i slot="reference" class="el-icon-warning" style="color: #abadb2;cursor: pointer; font-size:16px; margin-left: 5px;vertical-align: middle;" ></i>
                            </el-popover>
                        </div>
                        
                    </template>

                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination class="pagination" v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="getList" />

        </div>

        <!-- 导出任务列表 -->
        <el-dialog class="dialog-box" title="导出任务列表" :visible.sync="dialogDownload" width="70%" style="min-width: 550px;" top="10vh">
            <el-table class="grayTableTile_02" :data="exportTaskList" height="75vh">
                <el-table-column property="id" label="任务ID" min-width="200" sortable></el-table-column>
                <el-table-column property="ext01" label="任务名称" min-width="150" sortable></el-table-column>
                <el-table-column property="ext02" label="任务耗时(秒)" min-width="150" sortable></el-table-column>
                <el-table-column property="createTime" label="任务创建时间" min-width="150" sortable></el-table-column>
                <el-table-column property="status" label="状态" width="100" sortable>
                    <template slot-scope="scope">
                        <bdc-icon-tag v-if="isBdc && scope.row.status == '0'" variant="orange">初始化</bdc-icon-tag>
                        <bdc-icon-tag v-else-if="isBdc && scope.row.status == '1'" variant="main">正在执行</bdc-icon-tag>
                        <bdc-icon-tag v-else-if="isBdc && scope.row.status == '2'" variant="green">执行成功</bdc-icon-tag>
                        <bdc-icon-tag v-else-if="isBdc" variant="red">执行失败</bdc-icon-tag>
                        <span v-else-if="scope.row.status == '0'" style='color: #f8ac59;font-weight: bold;'>初始化</span>
                        <span v-else-if="scope.row.status == '1'" style='color: #1ab394;font-weight: bold;'>正在执行</span>
                        <span v-else-if="scope.row.status == '2'" style='color: #67C23A;font-weight: bold;'>执行成功</span>
                        <span v-else style='color: #F56C6C;font-weight: bold;'>执行失败</span>
                    </template>
                </el-table-column>
                <el-table-column property="downloadPath" label="操作" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '2'">
                            <el-link type="primary" :href="scope.row.downloadPath">下载</el-link>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 编辑指标 -->
        <norm-filter ref="norm" :sourceData="recordsList" @handleSave="handleSaveNorm"></norm-filter>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
// import Toolbar from './components/toolbar'
import Pagination from '@/components/Pagination'
import NormFilter from './components/normFilter'
import BdcIconTag from '@/components/BdcIconTag'
import { find_backflowRecordsHeader, find_backflowReport, sync_headerData, find_backflowDownloadTask, download_backflowReport } from '@Sys~/api/sys'
export default {
    name: name,
    components:{Pagination, NormFilter, BdcIconTag},
    data() {
        return {
            barHeight: '', // 筛选条件高度
            monitor:'date', // 维度
            // 表格
            tableloading: false,
            tableData:{
                headers:[],
                records:{},
                recordSum:[],
                init() {
                    this.headers = []
                    this.records = {}
                    this.recordSum = []
                }
            },
            total:0,
            listQuery:{
                pageNo: 1,
                pageSize: 20
            },

            // 所有指标 
            recordsList: [],

            // 排序
            sortColumn: '', //排序字段
            sortType:'', // 正序：asc  倒序：desc

            // 导出任务列表 弹窗
            downloadListLoading: false,
            dialogDownload: false,
            exportTaskList:[], // 导出数据列表
            // 导出
            downloadLoading: false
        }
    },
    computed: {
        ...mapGetters(['transitionEnter']),
        isBdc() {
            return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
        }
    },
    watch: {
        // 定位 bar
        transitionEnter(val) {
            // console.log('11111',val)
            if(val == 1 && this.$refs.bar) {
                // alert('222: '+this.$refs.bar.$el.offsetHeight)
                this.$nextTick(() => {
                    this.barHeight = Number(this.$refs.bar.$el.offsetHeight + 24) + 'px'
                })
            } else {
                this.barHeight = '24px'
            }
        },

        // 监听维度变化
        monitor(val) {
            this.tableData.init()
            this.getList() // 列表数据
        }
    },
    mounted() {
        window.onresize = () => {
            // console.log('1111fixedHeight', this.$refs.bar.$el.offsetHeight)
            if(this.$refs.bar) {
                this.barHeight = Number(this.$refs.bar.$el.offsetHeight + 24) + 'px'
            }
        } 
        
        
        // 获取游戏列表
        const bar = this.$refs.bar
        if(bar) {
            bar.getGameList(() => {
                this.getList() // 列表数据
            })
        }
       
    },

    methods: {
        // 列表数据
        getList() {
            
            const bar = this.$refs.bar
            // 媒体转换格式
            const media = JSON.parse(JSON.stringify(bar.media));
            let mediavalue=[];
            media.forEach(item => {
                mediavalue.push(item[item.length-1])
            })

            const data = {
                startDate: bar.dayTimes[0],
                endDate: bar.dayTimes[1],
                appkey: bar.appkey,
                medias: mediavalue,
                promotionGroupIds: bar.monitor,
                promotionIds: bar.monitorLink,
                dimension: bar.queryType,
                groupBy: this.monitor,
                clientOs: bar.clientOs,
                sortColumn: this.sortColumn, // 排序字段
                sortType: this.sortType, 
                pageNo: this.listQuery.pageNo,
                pageSize: this.listQuery.pageSize
            }

            this.tableloading = true
            find_backflowReport(data).then(response => {
                this.tableloading = false
                if(response.code == 1) {
                    const result = JSON.parse(JSON.stringify(response.data))
                    let headers = []
                    result.headers.forEach(item => {
                        if(item.children && item.children.length > 0) {
                            headers =  headers.concat(item.children)
                        }
                    })
                    this.total = result.records.totalCount
                    this.tableData.headers = headers // 表头
                    this.tableData.records = result.records // 数据
                    this.tableData.recordSum = result.recordSum // 汇总
                }
            })
        },

        // 导出任务列表
        handleDownloadList() {
            this.downloadListLoading = true
            find_backflowDownloadTask().then(response => {
                this.downloadListLoading = false
                if(response.code == 1) {
                    this.dialogDownload = true
                    this.exportTaskList = response.data
                }
            })

        },

        // 下载
        handleDownload() {
            this.downloadLoading = true
            const bar = this.$refs.bar
            // 媒体转换格式
            const media = JSON.parse(JSON.stringify(bar.media));
            let mediavalue=[];
            media.forEach(item => {
                mediavalue.push(item[item.length-1])
            })

            const data = {
                startDate: bar.dayTimes[0],
                endDate: bar.dayTimes[1],
                appkey: bar.appkey,
                medias: mediavalue,
                promotionGroupIds: bar.monitor,
                promotionIds: bar.monitorLink,
                dimension: bar.queryType,
                groupBy: this.monitor,
                clientOs: bar.clientOs,
                sortColumn: this.sortColumn, // 排序字段
                sortType: this.sortType, 
                pageNo: this.listQuery.pageNo,
                pageSize: this.listQuery.pageSize
            }
            download_backflowReport(data).then(response => {
                this.downloadLoading = false
                if(response.code == 1) {
                    this.$message({
                        message: '导出任务创建成功，在「导出任务列表」中可以查看进度。',
                        type: 'success'
                    });
                }
            })
        },

        // 合计
        getSummaries(param) {
            // console.log(param)
            var sums = [];
            var zongji = this.tableData.recordSum;
            var theads = param.columns;
            for (var i = 0; i < theads.length; i++) {
                var istrue = false;
                for (var j in zongji) {
                    if (theads[i].property == j) {
                        sums.push(zongji[j])
                        istrue = true;
                    }
                }
                if (!istrue) {
                    sums.push(theads[i].property)
                }
            }
            return sums;
        },

        // 监听排序变化
        handleAgeSortChange(e) {
            console.log(e)
            if (e.order) {
                this.sortColumn = e.prop
                this.sortType = e.order == 'ascending' ? 'asc' : 'desc'
                this.listQuery.pageNo = 1
                this.getList()
            } else {
                this.sortColumn = ''
                this.sortType = ''
                this.getList()
            }
        },

        // 查询
        handleFilter() {
            this.listQuery.pageNo = 1
            this.getList();
        },

        // 筛选指标
        handleEditNorm() {
            this.$refs['norm'].init()
            this.getRecords() // 获取指标列表
        },
        // 获取指标列表
        getRecords() {
            find_backflowRecordsHeader().then(response => {
                this.$refs['norm'].loading = false
                if (response.code == 1) {
                // console.log(response)
                const data = JSON.parse(JSON.stringify(response.data))
                data.forEach(arr => {
                    let nums = 0;
                    arr.children.forEach(item => {
                    if (item.checked) {
                        nums++
                    }
                    })

                    if (nums == arr.children.length) {
                    arr.checked = true
                    } else {
                    arr.checked = false
                    }
                })

                // this.$refs['norm'].sourceData = data
                this.recordsList = data
                }
            })
        },

        // 保存指标
        handleSaveNorm(list) {
            const ids = []
            list.forEach(item => {
                if (item.children && item.children.length > 0) {
                item.children.forEach(item => {
                    if (item.checked) {
                    ids.push(item.id)
                    }
                })
                }
            })

            const data = {
                ids: ids,
                projectCode: 'backflow_report'
            }
            // console.log(ids)
            sync_headerData(data).then(response => {
                this.$refs['norm'].dialogLoading = false
                if (response.code == 1) {
                    this.$refs['norm'].dialogTableVisible = false
                    this.getList();
                }
            })
        },

        // 跳转
        handleJump() {
            window.open('https://note.youdao.com/s/JiqsCnjF')
        }
    }
}
</script>

<style lang="scss" scoped>
.fixed-page{
  min-height: calc(100vh - 84px);
  overflow: hidden;
  background: #F0F2F5;
}
.margin-container{
    margin-left: 32px;
    margin-right: 32px;
    margin-bottom: 24px;
    padding: 24px;
    background: #FFFFFF;
    border-radius: 4px;
}
.desc-box{
    height: 24px;
    line-height: 24px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    h3{
        margin: 0;
        font-weight: 400;
    }
    .title{
        font-size: 18px;
        color: #333333;
        margin-right: 12px;
    }
    .text{
        font-size: 12px;
        color: #999999;
    }
    .link{
        cursor: pointer;
        font-size: 12px;
        color: #3A89FF;
    }
}
.operate-box{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    ::v-deep .el-radio-button--medium .el-radio-button__inner{
        padding: 10px 15px;
    }
    ::v-deep .el-radio-button:first-child .el-radio-button__inner{
        border-radius: 6px 0 0 6px;
    }
    ::v-deep .el-radio-button:last-child .el-radio-button__inner{
        border-radius: 0 6px 6px 0;
    }
    ::v-deep .el-button{
        background: #FFFFFF;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
        border-radius: 6px;
        border: 1px solid #E5E5E5;
    }
    ::v-deep .el-button--medium{
        padding: 10px 14px;
    }
}
.pagination{
    padding: 20px 16px 4px;
}

.dialog-box{
    ::v-deep .el-dialog__body{
        padding: 0px 10px 10px;
    }
}

.grayTableTile_02 ::v-deep .el-table__body-wrapper {
  z-index: 1;
}

::v-deep .el-table th>.cell{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding-left: 6px;
    padding-right: 6px;
    min-height: 44px;
}

::v-deep .el-table .caret-wrapper{
    height: 32px;
}
::v-deep .el-table .sort-caret.descending{
    bottom: 4px;
}
</style>